import { Injectable } from '@angular/core';
import { HttpService } from './core/http.service';
import { Observable } from 'rxjs';
import { TaxonomyItem } from '../models/services/taxonomy';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TaxonomyService {

  constructor(
    private httpService: HttpService    
  ) { }

  public getTaxonomyTree = (): Observable<TaxonomyItem[]> => {
    let url: string = `${environment.adminServicesApiBaseUri}/master/taxonomy-items`;
    return this.httpService.get(url, undefined);
  }  

  public updateTaxonomyItem = (iabMaster: TaxonomyItem): Observable<void> => {
    let url: string = `${environment.adminServicesApiBaseUri}/master/taxonomy-items`;
    return this.httpService.putNoResponse(url, iabMaster);
  }  

  public joinTaxonomyItem = (id: string, targetId: string): Observable<void> => {
    let url: string = `${environment.adminServicesApiBaseUri}/master/taxonomy-items/${id}/join/${targetId}`;
    return this.httpService.postNoResponse(url, null);
  } 

  public isMaintenanceLocked = (): Observable<boolean> => {
    let url: string = `${environment.adminServicesApiBaseUri}/master/taxonomy-items/locked`;
    return this.httpService.get(url, null);
  }      
}
